<template>
  <div class="root">
    <div class="temperatures">
      <div class="left-temp">
        <span class="label">in </span>
        <span class="temp">{{ insideTemp }}&deg;</span>
      </div>
      <div class="right-temp">
        <span class="label">out </span>
        <span class="temp">{{ outsideTemp }}&deg;</span>
      </div>
    </div>
    <br />
    <div class="time">
      <span>{{ time }}</span>
    </div>
    <div v-if="mode === 'cool'" class="mode-icon snowflake">❄</div>
    <div v-else-if="mode === 'heat'" class="mode-icon flame">
      <img src="@/assets/flame.png" alt="flame" />
    </div>
    <span v-if="this.isPast9PM()" class="nighttime">
      <div v-if="this.isEvenDate()" class="mode-icon even">
        <img src="@/assets/pink heart.png" alt="pink heart" />
      </div>
      <div v-else class="mode-icon odd">
        <img src="@/assets/blue heart.png" alt="blue heart" />
      </div>
    </span>
  </div>
</template>

<script>
import * as Temps from "./Temps";
const Weather = require("./Weather");

function currentTime() {
  let date = new Date();
  let hour = date.getHours();
  let minutes = date.getMinutes();
  if (minutes < 10) {
    minutes = "0" + minutes;
  }

  let bodyStyles = document.body.style;
  if (hour > 7 && hour < 20) {
    bodyStyles.setProperty("--time-color", "#a8350f");
  }
  if (hour > 12) {
    hour -= 12;
  }
  let currentTime = hour + ":" + minutes;

  return currentTime;
}

export default {
  name: "WebClock",
  data() {
    return {
      time: "00:00",
      theme: "night",
      insideTemp: 0,
      outsideTemp: 0,
      mode: null,
    };
  },
  methods: {
    updateTime: function () {
      this.time = currentTime();
    },
    updateBackground: function () {
      const forecast = Weather.getImminentForecast();
      console.log({ forecast: forecast });
    },
    updateTemps: async function () {
      let bodyStyles = document.body.style;
      let temps = await Temps.getTemps();
      if (temps) {
        console.log("Temps in webclock is: " + JSON.stringify(temps, null, 2));
        this.insideTemp = temps.upstairs?.toFixed(1);
        this.outsideTemp = temps.outside?.toFixed(1);
        this.mode = temps.mode;
        console.log("Mode set to: " + this.mode);
        bodyStyles.setProperty("--temp-color", "#add8e6");
      } else {
        console.log("temps is empty");
        // Turn the temp color yellow to indicate the problem reading temps
        bodyStyles.setProperty("--temp-color", "#999900");
        //this.insideTemp = -459.67;
      }
      this.updateBackground();
    },
    isPast9PM: function () {
      const date = new Date();
      const hour = date.getHours();
      console.log("hour is: " + hour);
      return hour >= 21;
    },
    isEvenDate: function () {
      const date = new Date();
      const day = date.getDate();
      return day % 2 === 0;
    },
  },
  beforeMount() {
    let bodyStyles = document.body.style;
    bodyStyles.setProperty("--time-color", "#a8350f");
    bodyStyles.setProperty("--bg-color", "#000000");
    this.updateTemps();
    setInterval(this.updateTime.bind(this), 1000);
    setInterval(this.updateTemps.bind(this), 60000);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* https://fonts.google.com/specimen/Roboto?sidebar.open=true&selection.family=Roboto:wght@500 */
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap");

/*  background-image: url("../assets/sunny_day4.jpeg"); */
.root {
  background-color: var(--bg-color);
  background-size: cover;
}
.temperatures {
  font-family: "Roboto", sans-serif;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
}
.label {
  font-size: 8vw;
  color: #78777b;
}
.temp {
  font-size: 13vw;
  color: var(--temp-color);
  opacity: 0.7;
}
.time {
  font-size: 38vw;
  color: var(--time-color);
  font-family: "Roboto", sans-serif;
}
.mode-icon {
  position: fixed;
  bottom: 20px;
  left: 20px;
  font-size: 8vw;
  opacity: 0.7;
  z-index: 1000;
  background-clip: text;
  -webkit-background-clip: text;
}
.snowflake {
  color: #add8e6;
}
.flame {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.flame img {
  height: auto;
  max-width: 120px;
  max-height: 120px;
}
.nighttime img {
  position: fixed;
  bottom: 20px;
  right: 20px;
  opacity: 0.6;
  z-index: 1000;
  width: 10%;
  height: 10%;
}
</style>
